const basicNameRe = /^\S.*[^.\s]$/
const queryNameRe = /^[\w -_]+$/

export { basicNameRe, queryNameRe }



// WEBPACK FOOTER //
// ./src/utilities/regex/basic.js